import type { TagProps } from 'element-plus'

export enum MinerStatus {
  Inventoried = 'Inventoried',
  Cleaned = 'Cleaned',
  Diagnosed = 'Diagnosed',
  DiagnosticPassed = 'Diagnostic Passed',
  DiagnosticFailed = 'Diagnostic Failed',
  Blocked = 'Blocked',
  RepairAuthRequested = 'Repair Authorization Requested',
  RepairAuthDenied = 'Repair Authorization Denied',
  RepairInProgress = 'Repair In Progress',
  Completed = 'Completed',
  FailedStressTest = 'Failed Stress Test',
}

export const MinerStatusTagTypes: Record<MinerStatus, TagProps['type']> = {
  [MinerStatus.Inventoried]: 'info',
  [MinerStatus.Cleaned]: 'primary',
  [MinerStatus.Diagnosed]: 'info',
  [MinerStatus.DiagnosticPassed]: 'info',
  [MinerStatus.DiagnosticFailed]: 'warning',
  [MinerStatus.Blocked]: 'warning',
  [MinerStatus.RepairAuthRequested]: 'warning',
  [MinerStatus.RepairAuthDenied]: 'warning',
  [MinerStatus.RepairInProgress]: 'primary',
  [MinerStatus.Completed]: 'success',
  [MinerStatus.FailedStressTest]: 'warning',
}
